$(document).ready(function () {
  if ($('.js-next-course__countdown').length) {

    var timeinterval = setInterval(function () {
      var countdown_field = $('.js-next-course__countdown');
      var seconds = countdown_field.data('seconds');

      if ((seconds !== undefined) && (seconds > 1)) {
        new_seconds = seconds - 1;
        countdown_field.data('seconds', new_seconds);
        countdown_field.text(
          (new_seconds == 1) ? '1 second' : new_seconds + ' seconds'
        );
      } else {
        clearInterval(timeinterval);
        window.parent.location = $('.js-continue-url').attr('href');
      }

    }, 1000);

  }
})
